"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = exports.lightTheme = void 0;
var lightTheme_1 = require("./lightTheme");
Object.defineProperty(exports, "lightTheme", { enumerable: true, get: function () { return lightTheme_1.lightTheme; } });
var darkTheme_1 = require("./darkTheme");
Object.defineProperty(exports, "darkTheme", { enumerable: true, get: function () { return darkTheme_1.darkTheme; } });
//# sourceMappingURL=index.js.map